export default function ListingCard({ listing }) {
  const isRent = listing.type === "ALUGUEL";
  const priceDisplay = isRent 
    ? `R$ ${listing.price.toLocaleString("pt-BR")}/mês`
    : `R$ ${listing.price.toLocaleString("pt-BR")}`;

  return (
    <div className="listing-card">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem", flexWrap: "wrap", gap: "0.5rem" }}>
        <div className="tag" style={{ 
          background: isRent 
            ? "linear-gradient(135deg, rgba(0, 86, 179, 0.15) 0%, rgba(0, 86, 179, 0.25) 100%)"
            : "linear-gradient(135deg, rgba(34, 139, 34, 0.15) 0%, rgba(34, 139, 34, 0.25) 100%)",
          color: isRent ? "var(--brand-blue)" : "var(--brand-green)",
          borderColor: isRent ? "rgba(0, 86, 179, 0.3)" : "rgba(34, 139, 34, 0.3)"
        }}>
          {listing.type || "VENDA"}
        </div>
        <div className="tag">{listing.portal}</div>
      </div>
      <h4>{listing.title}</h4>
      <div style={{ 
        fontSize: "1.5rem", 
        fontWeight: 700, 
        color: isRent ? "var(--brand-blue)" : "var(--brand-green)",
        letterSpacing: "-0.02em",
        margin: "0.75rem 0"
      }}>
        {priceDisplay}
      </div>
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        gap: "0.5rem", 
        color: "var(--text-secondary)",
        marginBottom: "0.75rem",
        fontSize: "0.9rem"
      }}>
        <span>📍</span>
        <span>{listing.location}</span>
      </div>
      {listing.bedrooms && (
        <div style={{ 
          display: "flex", 
          gap: "1rem", 
          marginBottom: "0.75rem",
          flexWrap: "wrap",
          fontSize: "0.85rem",
          color: "var(--text-secondary)"
        }}>
          {listing.bedrooms > 0 && <span>🛏️ {listing.bedrooms} quartos</span>}
          {listing.bathrooms > 0 && <span>🚿 {listing.bathrooms} banheiros</span>}
          {listing.parkingSpots > 0 && <span>🚗 {listing.parkingSpots} vagas</span>}
          {listing.area > 0 && <span>📐 {listing.area}m²</span>}
        </div>
      )}
      <div style={{ 
        color: "var(--text-secondary)", 
        lineHeight: 1.6,
        fontSize: "0.9rem"
      }}>
        {listing.summary}
      </div>
    </div>
  );
}
